import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import {BlogcategoryService} from "../../../api/blogcategory/blogcategory.service";
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './blogcategory.html'
})

export class Blogcategory implements OnInit {
    blogcategory = [];
    i: number;
    id: string;
    category: string;

    constructor(private blogcategoryService: BlogcategoryService,
                private router: Router ,private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Blog Category  | Phoenix Games");
        if (localStorage.getItem('token') && localStorage.getItem('role') == 'SUPERADMIN') {
            this.blogcategoryService.allBlogcategory()
                .then(data => {
                    this.blogcategory = data;

                });
        } else {
            this.router.navigate(['/']);
        }
    }

    cancelAction() {
        this.id = "";
        this.category = "";
    }

    submitBlogcategory() {
        if (this.category == undefined || this.category == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            var appData = {
                category: this.category
            };
            this.blogcategoryService.iBlogcategory(appData).then(data => {
                if (data.status) {
                    this.blogcategory.push(data.data);
                    this.cancelAction();
                    $.notify({
                        message: "Inserted Successfully"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: "Try Again"
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction();
                }
            });
            $(function () {
                $('#addBlogcategory').modal('toggle');
            });
        }
    }


    showBlogcategory(blogcategory, i) {
        this.i = i;
        this.id = blogcategory.id;
        this.category = blogcategory.category;
    }

    deleteconfirmation(id, i) {
        //alert(JSON.stringify(keydata))
        this.i = i;
        this.id = id;
    }

    updateBlogcategory() {
        if (this.category == undefined || this.category == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            var appData = {
                category: this.category
            };
            this.blogcategoryService.uBlogcategory(this.id, appData).then(data => {
                if (data.status) {
                    this.blogcategory[this.i] = data.data;
                    this.cancelAction();
                    $(function () {
                        $('#updateBlogcategory').modal('toggle');
                    });
                    $.notify({
                        message: "Updated Successfully"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    deleteBlogcategory() {
        this.blogcategoryService.dBlogcategory(this.id).then(data => {
            if (data.status) {
                this.blogcategory.splice(this.i, 1);
                $.notify({
                    message: "Deleted Successfully"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();

                $.notify({
                    message: "Error"
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        });
    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blogcategory/blogcategory.page.ts